import { Component, Input, OnInit, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { MenuService } from 'src/app/core/services/menu.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { getConnection, getCurrentUser, hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { MatDialog } from '@angular/material/dialog';
import { SearchComponent } from '../search/search.component';
import { environment } from 'src/environments/environment';
import { UsuarioAuth } from 'src/app/modules/auth/models/auth.models';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  user: UsuarioAuth;

  @ViewChild('navbarElement', { static: true }) navbarElement!: ElementRef;
  private resizeObserver!: ResizeObserver;

  // Entradas del componente para mostrar menú y buscador
  @Input() showMenu: boolean = false;
  @Input() showSearch: boolean = false;

  environment = environment;
  c_emp = getConnection();

  // Correo de soporte técnico
  readonly supportEmail = 'merlin@jamar.com';

  constructor(
    private router: Router,
    private authService: AuthService,
    private helpers: HelpersService,
    private menuService: MenuService,
    private dialog: MatDialog
  ) {
  }


  ngOnInit(): void {
    try {
      this.user = getCurrentUser();
    } catch (e) {
      console.error("No se pudo obtener el usuario:", e);
    }
  }

  ngAfterViewInit(): void {
    this.setNavbarHeight();
    this.resizeObserver = new ResizeObserver(() => {
      this.setNavbarHeight();
    });
    if (this.navbarElement?.nativeElement) {
      this.resizeObserver.observe(this.navbarElement.nativeElement);
    }
  }

  setNavbarHeight() {
    if (this.navbarElement?.nativeElement) {
      const navbarHeight = this.navbarElement.nativeElement.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${navbarHeight}px`);
    }
  }

  logout() {
    this.authService.logOut();
  }

  async reloadModules() {
    this.menuService.deleteModules()
    showSpinner("Actualizando módulos")
    const result = await this.menuService.requestModules()
    hideSpinner()
    if (result.success) {
      this.helpers.notifications.successMessage(result.message)
      if (location.href.includes("#/home")) {
        this.router.navigate(["/home"])
        setTimeout(() => {
          location.reload()
        }, 100);
      }
    } else {
      this.helpers.notifications.warningMessage(result.message)
    }
  }

  deleteRecents() {
    this.menuService.deleteRecentModules()
    if (location.href.includes("#/home")) {
      setTimeout(() => {
        location.reload()
      }, 100);
    }
  }

  showModal(isSearch: boolean) {
    let options = {
      data: { isSearch: isSearch },
      width: "90%",
      maxWidth: "500px",
      maxHeight: "90vh",
      height: "fit-content",
    }
    if (window.innerWidth > 768) {
      options["position"] = {
        top: "20px",
        right: "20px"
      }
    } else {
      options["position"] = {
        top: "20px",
        // right: event.offsetX + "px"
      }
    }
    this.dialog.open(SearchComponent, options)
  }

  openOldAdmin() {
    window.open(this.environment.domain + '/JamarAdminAPP/#/', '_blank');
  }

  openSupport() {
    window.location.href = `mailto:${this.supportEmail}?subject=Soporte técnico - Plataforma`;
  }

  // Devuelve la URL de la bandera correspondiente al código de empresa
  getFlagUrl(codigo: string): string {
  const flags = {
    JP: 'https://static.abstractapi.com/country-flags/PA_flag.svg',
    JC: 'https://static.abstractapi.com/country-flags/CR_flag.svg',
    JA: 'https://static.abstractapi.com/country-flags/CO_flag.svg'
  };
  return flags[codigo] || '';
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
  
}
